import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NavigationExtras, Router, RouterModule } from '@angular/router';
import { Params } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-empty-list',
  styleUrls: ['./empty-list.component.scss'],
  templateUrl: './empty-list.component.html',
  imports: [MatIconModule, RouterModule],
})
export class EmptyListComponent {
  @Input() public iconName = 'svg_search_guide';
  @Input() public link: string;
  @Output() public linkClickedEvent = new EventEmitter<void>();
  @Input() public linkText: string | null;
  @Input() public message1 = 'Aucun résultat pour les critères sélectionnés.';
  @Input() public message2: string;
  @Input() public queryParams: Params;

  private _router: Router = inject(Router);

  public linkClickedHandler(): void {
    if (this.link) {
      let navigationExtras: NavigationExtras | undefined;
      if (this.queryParams) {
        navigationExtras = {
          queryParams: this.queryParams,
        };
      }

      this._router.navigate([this.link], navigationExtras);
    }
    this.linkClickedEvent.emit();
  }
}
